import config from '../config';

export const getPersonalizeUrl = (staffid, studentid, courseid) => {
    return `${config.PERSONALIZE_URL}?staffid=${staffid}&studentid=${studentid}&courseid=${courseid}`;
};
